import { useEffect } from 'react';
import useIntercomCustomAttributes from '@hooks/lib/useIntercomCustomAttributes';
import { useAuth } from '@lusha/auth-client-sdk';
import { boot } from '@intercom/messenger-js-sdk';
import { Intercom } from "@intercom/messenger-js-sdk";
function LushaIntercomProvider(props) {
    const { children } = props;
    const customAttributes = useIntercomCustomAttributes();
    const { user } = useAuth();
    const { email } = user || {};
    useEffect(() => {
        if (email) {
            Intercom(Object.assign({ region: 'eu' }, customAttributes));
            boot(customAttributes);
        }
    }, [email]);
    return children;
}
export default LushaIntercomProvider;
